<canvas class="ym-fixed ym-top-0 ym-left-0 ym-max-w-100vw ym-h-100vh" #confettiCanvas></canvas>